import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/download.tsx
var Download = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M20 15V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V15M12 14.5V4M12 14.5L8.5 11M12 14.5L15.5 11",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3.25C12.4142 3.25 12.75 3.58579 12.75 4V12.6893L14.9697 10.4697C15.2626 10.1768 15.7374 10.1768 16.0303 10.4697C16.3232 10.7626 16.3232 11.2374 16.0303 11.5303L12.5303 15.0303C12.3897 15.171 12.1989 15.25 12 15.25C11.8011 15.25 11.6103 15.171 11.4697 15.0303L7.96967 11.5303C7.67678 11.2374 7.67678 10.7626 7.96967 10.4697C8.26256 10.1768 8.73744 10.1768 9.03033 10.4697L11.25 12.6893V4C11.25 3.58579 11.5858 3.25 12 3.25ZM4 14.25C4.41421 14.25 4.75 14.5858 4.75 15V18C4.75 18.6904 5.30964 19.25 6 19.25H18C18.6904 19.25 19.25 18.6904 19.25 18V15C19.25 14.5858 19.5858 14.25 20 14.25C20.4142 14.25 20.75 14.5858 20.75 15V18C20.75 19.5188 19.5188 20.75 18 20.75H6C4.48122 20.75 3.25 19.5188 3.25 18V15C3.25 14.5858 3.58579 14.25 4 14.25Z",
		fill: "currentColor"
	})
});
//#endregion
export { Download };
